const DubbleArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="144"
      height="35"
      viewBox="0 0 144 35"
      fill="none"
    >
      <path
        d="M0 0L2.86441 11.1861L11.1196 3.11239L0 0ZM144 0L132.766 2.67192L140.697 11.0646L144 0ZM5.61156 7.16631C18.2743 18.9347 37.776 30.9985 60.9489 34.0546C84.167 37.1167 110.967 31.1203 138.117 6.93451L136.787 5.44112C110.049 29.26 83.823 35.0541 61.2104 32.0718C38.5528 29.0836 19.4188 17.268 6.9731 5.70131L5.61156 7.16631Z"
        fill="#93B2F2"
      />
    </svg>
  );
};
export default DubbleArrow;
